<div class="confirm-dialog ups-dialog {{ dialogClass }}">
    <h2 mat-dialog-title *ngIf="title && !isSingleInvoice" [ngClass]="titleClass">{{ title }}</h2>
    <div class="key-key" *ngIf="!isSingleInvoice"></div>
    <mat-dialog-content [class.singleInvoice-mat-dialog-content]="isSingleInvoice" [class.notSingleInvoice-mat-dialog-content]="!isSingleInvoice">
        <div class="dialog-content {{ messageClass }}" [innerHtml]="message"></div>

        <mat-radio-group [(ngModel)]="selectedOption" *ngIf="!isSingleInvoice">
            <mat-radio-button value="option1"> 
                Apply to the oldest outstanding invoice: &nbsp; 
                <div> 
                    <a (click)="downloadInvoice(oldestInvoice?.invoiceID)" href="javascript:;" class="spanned_invoiceID">{{oldestInvoice?.invoiceID }} </a>
                    ${{oldestInvoice?.balance | number: '0.0-2' }}
                </div>
            </mat-radio-button>

            <div class="invoice-wrapper" [class.content-disabled]="!hasMultipleInvoices">
                <mat-radio-button value="option2"> Select Invoice: </mat-radio-button>
                <mat-form-field class="invoice-form-field" appearance="outline">
                    <mat-label> {{selectLabel}} </mat-label>
                    <mat-select [(ngModel)]="selectedInvoice" [panelClass]="'ups-select-in-dialog'">
                      <mat-option *ngFor="let invoice of openInvoiceLists" [value]="invoice"> 
                        {{invoice.business}}_{{invoice.invoiceID}} | {{invoice.dueDate}} | ${{invoice.balance | number: '0.0-2'}} </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
        </mat-radio-group>

        <div class="invoiceid-container" *ngIf="isSingleInvoice">
            <h2> Invoice Number: 
                <a (click)="downloadInvoice(singleInvoiceID)"
                href="javascript:;">{{singleInvoiceID }}</a>
                <!-- <span class="spanned_invoiceID"> {{singleInvoiceID}} </span>  -->
            </h2> 
            <h2> Balance: ${{singleInvoiceBalance | number: '0.0-2'}} </h2>
        </div>
        
        <div class="available-points">
            <h2> Available Points: {{availablePoints}} </h2>
            <h5> Please enter how many points you would like to redeem. </h5>
            <div class="available-points-btns">
                <button mat-button color="primary" (click)="setCustomAmount(10)"> 10 PTS </button>
                <button mat-button color="primary" (click)="setCustomAmount(50)"> 50 PTS </button>
                <button mat-button color="primary" (click)="setCustomAmount(100)"> 100 PTS </button>
                <button mat-button color="primary" (click)="setCustomAmount(null)"> MAX PTS </button>
            </div>
        </div>

        <div class="custom-amount">
            <mat-form-field class="custom-amount-form-field" appearance="outline">
                <mat-label class="custom-amount-label"> Custom Amount </mat-label>
                <input matInput type="number" [formControl]="form_customAmount" (input)="validateAndFormatTwoDecimalPlaces($event)" required>
            </mat-form-field>
            <h6 *ngIf="customAmount"> {{customAmount | number: '0.0-2'}} points = ${{customAmount | number : '0.0-2'}}</h6>
            <mat-error class="my-error" *ngIf="!form_customAmount.valid"> {{exceedAvailablePointsErrorMessage()}} </mat-error> 
            <mat-error class="my-error" *ngIf="form_customAmount.hasError('cannotRedeem')">{{remainingPointsRedeemedLaterErrorMessage()}} </mat-error>
            <mat-error class="my-error" *ngIf="form_customAmount.hasError('invalidFormat')">{{invalidCustomAmountFormat()}}</mat-error>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button mat-raised-button (click)="redeemRewards()" [disabled]="!form_customAmount.valid || isCustomAmountZero()">
            {{yes}} <span class="material-symbols-outlined">chevron_right</span> 
        </button>
        <button mat-raised-button (click)="cancelRewards()" class="alternative-button" mat-dialog-close tabIndex="1">{{cancel}} <span class="material-symbols-outlined">chevron_right</span> </button>
    </mat-dialog-actions>

    <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close> 
        <mat-icon>close</mat-icon>
    </button>
</div>
